import api from "../../../../../api/api"





const importTallyLedgerGroups = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/ledger/groups",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const importTallyLedgers = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/ledger/ledgers",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const ledgerImportServices = {
    
    importTallyLedgerGroups,
    importTallyLedgers,

}

export default ledgerImportServices;